import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionPlanPreQuestionsRoot } from "./pre-questions";

import type { DayTripPlanI18nCategoriesAndManagerStore } from "../../_store/categories";

type Props = {
	preQuestions: DayTripPlanI18nCategoriesAndManagerStore["preQuestions"];
};

export const QuestionPlanPreQuestions = ({ preQuestions }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper islandTitle="事前質問" categoryStore={preQuestions}>
			<QuestionPlanPreQuestionsRoot />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionPlanPreQuestions.displayName = "QuestionPlanPreQuestions";
